import { render, staticRenderFns } from "./noticeModal.vue?vue&type=template&id=f72172a6&scoped=true&"
import script from "./noticeModal.vue?vue&type=script&lang=ts&"
export * from "./noticeModal.vue?vue&type=script&lang=ts&"
import style0 from "@/styles/modal/modal.scss?vue&type=style&index=0&id=f72172a6&lang=scss&scoped=true&"
import style1 from "./noticeModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f72172a6",
  null
  
)

export default component.exports